module.exports = __webpack_public_path__ + "static/img/yk6210.4b3bb50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6210.png
// module id = NIv7
// module chunks = 1